/* eslint-disable @typescript-eslint/no-explicit-any */
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
class CanvasManager {
  private canvas: any;
  private isDrawingModeOpen: boolean = false;
  backgroundImage: any;
  constructor(canvas: any) {
    this.canvas = canvas;
  }

  loadJson(data: any): void {
    this.canvas.loadFromJSON(data);
  }
  bringToFront(obj: any) {
    this.canvas.bringToFront(obj);
  }

  sendToBack(obj: any) {
    this.canvas.sendToBack(obj);
  }
  addObject(object: any): void {
    this.canvas.add(object);
  }

  canvasRenderAll(): void {
    this.canvas.requestRenderAll();
  }

  getCanvas(): any {
    return this.canvas;
  }

  onCanvasRender(callback: () => void): void {
    this.canvas.on('after:render', () => {
      callback();
    });
  }

  off(mode: string) {
    this.canvas.off(mode);
  }

  on(mode: string, callback: (event: any) => void): void {
    this.canvas.on(mode, (e: any) => callback(e));
  }
  getCanvasSize(): { width: number; height: number } {
    return { width: this.canvas.width, height: this.canvas.height };
  }
  removeObject(object: any): void {
    this.canvas.remove(object);
    this.canvas.requestRenderAll();
  }

  removeObjectById(id: string): void {
    const objects = this.getObjectsById(id);
    objects.forEach((obj) => this.removeObject(obj));
  }

  sourceClick(): void {
    this.canvas.isDrawingMode = false;
  }

  cancelDraw(): void {
    this.canvas.cancelDraw = true;
  }
  openDraw(): void {
    this.canvas.cancelDraw = false;
  }
  closeDrawingMode(): void {
    this.isDrawingModeOpen = this.canvas.isDrawingMode;
    this.canvas.isDrawingMode = false;
  }

  openDrawingMode(): void {
    this.canvas.isDrawingMode = this.isDrawingModeOpen;
  }

  moveObjectToBack(object: any): void {
    this.canvas.moveTo(object, -100);
    this.canvas.requestRenderAll();
  }

  setBackgroundImage(
    imageUrl: string,
    options: any,
    callback?: () => void,
  ): void {
    fabric.Image.fromURL(imageUrl, (img: any) => {
      this.canvas.setBackgroundImage(img, null, options);
      const onRenderComplete = () => {
        this.canvas.off('after:render', onRenderComplete); // Olayı dinlemeyi bırak
        if (callback) callback(); // Callback'i çalıştır
      };
      this.canvas.on('after:render', onRenderComplete); // Render tamamlandıktan sonra çağır
      this.canvas.requestRenderAll(); // Render işlemini başlat
    });
  }

  getBackgroundImage(): any {
    return this.canvas.backgroundImage
  }
  getBackgroundImageCoordinate(): { imgLeft: any; imgTop: any } {
    const imgLeft = this.canvas.backgroundImage?.aCoords
      ? this.canvas.backgroundImage.aCoords.bl.x
      : 0;
    const imgTop = this.canvas.backgroundImage?.aCoords
      ? this.canvas.backgroundImage.aCoords.tl.y
      : 0;
    return { imgLeft, imgTop };
  }

  getBackgroundImageLineCoordinate(): { imgLeft: any; imgTop: any } {
    const imgLeft = this.canvas.backgroundImage?.lineCoords
      ? this.canvas.backgroundImage.lineCoords.bl.x
      : 0;
    const imgTop = this.canvas.backgroundImage?.lineCoords
      ? this.canvas.backgroundImage.lineCoords.tl.y
      : 0;
      console.log(this.canvas.backgroundImage)
    return { imgLeft, imgTop };
  }

  getObjectsById(id: string): any[] {
    return this.canvas
      .getObjects()
      .filter((obj: any) => (obj as any).id === id);
  }

  getObjects(): any[] {
    return this.canvas.getObjects();
  }
  clearCanvas(): void {
    this.canvas.clear();
  }
  getCanvasScale(): number {
    const scale =
      (this.canvas.backgroundImage.lineCoords.br.x -
        this.canvas.backgroundImage.lineCoords.bl.x) /
      this.canvas.backgroundImage.width;

      return scale;
  }

  getPointer(o: any): any {
    return this.canvas.getPointer(o.e);
  }
  getviewportTransform(): any {
    return this.canvas.viewportTransform;
  }
}

export default CanvasManager;
